import { Component, OnInit, ViewChild } from '@angular/core';
import { MessagesService } from 'src/app/Services/Messages/messages.service';
import { ToastrService } from 'ngx-toastr';
import { FormBuilder } from '@angular/forms';
import { IMessagingSender } from 'src/app/models/IMessaging';
import { MatTableDataSource, MatSort, MatDialog } from '@angular/material';
import { Router, ActivatedRoute } from '@angular/router';
import { IMessagetype } from 'src/app/models/IMessagetype';
import { RxService } from 'src/app/Services/NewVisitNote/rx.service';
import { IERxRefills } from 'src/app/models/IERxRefills';
import { Defaults } from 'src/app/Utilities/defaults';
import { TransforUsersComponent } from 'src/app/ChildControls/transfor-users/transfor-users.component';
import { SharedService } from 'src/app/Sharedservice/SharedService';
import { MatPaginator } from '@angular/material/paginator';

@Component({
  selector: 'app-view-messages',
  templateUrl: './view-messages.component.html',
  styleUrls: ['./view-messages.component.css']
})
export class ViewMessagesComponent implements OnInit {
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  displayedColumns1 = ['id', 'SentFrom', 'Subject', 'Message', 'Date', 'priority'];

  Messagesdata: any[] = [];
  dataSource1 = new MatTableDataSource(this.Messagesdata);

  displayedColumns: string[] = ['Date', 'patientname', 'dob', 'Provider', 'assignedto', 'RequestType', 'Medication', 'sig', 'Pharmacy', 'Status', 'Actions'];
  //dataSource = ELEMENT_DATA;

  Refilldata: any[] = [];
  dataSource2 = new MatTableDataSource(this.Refilldata);
  userId: string = "";

  public categoryId: any;
  messagesDataSource = new MatTableDataSource();
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  constructor(private formBuilder: FormBuilder, private toastr: ToastrService, private messageService: MessagesService, private router: Router, private route: ActivatedRoute, private rxService: RxService, private sharedService: SharedService, public dialog: MatDialog) { }

  ngOnInit() {
    this.messagesDataSource.paginator = this.paginator;
    var loggedProvider = '';
    if (sessionStorage.getItem("role") == Defaults.doctorType) {
      loggedProvider = sessionStorage.getItem("userId");
      this.userId = loggedProvider
    }

    this.route.paramMap.subscribe(params => {
      this.categoryId = params.get('id');
      if (this.categoryId != 1)
        this.loadMessages();
      else
        this.getAllMessages("");
      //this.refillRequest();
      //this.getAllMessages("");
    });
  }
  messages: IMessagingSender[] = [];

  loadMessages() {
    this.refillDatasource = false;
    this.messageService.getAllMessages(sessionStorage.getItem("userId"), false).subscribe(data => {
      this.messages = data;
      this.messages = this.messages.filter(a => a.messageType == this.categoryId);
      this.dataSource1.data = this.messages;
    },
      (err: any) => console.log(err)
    );
  }

  onClickRenewal(selectedRow: IMessagingSender) {
    if (selectedRow.messageName == 'RX REFILL' && selectedRow.ssrId != 0)
      this.router.navigateByUrl('/RenewalRequest?reqId=' + selectedRow.ssrId + '&&reqType=' + selectedRow.messageName + '&&typeName=RX REFILL');
    else if (selectedRow.messageName == 'RX CHANGE' && selectedRow.ssrId != 0)
      this.router.navigateByUrl('/ChangeRequest?reqId=' + selectedRow.ssrId + '&&reqType=' + selectedRow.messageName + '&&typeName=RX CHANGE');
    else
      this.router.navigate(['RenewalRequest']);
  }

  OnTransforPopUp(selectedRow: IMessagingSender): void {
    var deast = selectedRow.deaStatus;
    const dialogRef = this.dialog.open(TransforUsersComponent, {
      width: '380px',
      height: '210px',
      data: selectedRow,
    });

    dialogRef.afterClosed().subscribe(result => {
      // if (result && result != undefined)
      //   this.UpdateTransforUser(result.userId, result.roleId, selectedRow);
      if (result && result != undefined) {


        if (!result.userName.includes('(Doctor)') && deast != '0' && deast != '') {
          this.toastr.error('Cannot transfer the request as the provider is not authorized to prescribe Controlled Substances.');
          return;
        }
        if (result.userName.includes('(Doctor)') && deast != '0' && deast != '') {
          this.rxService.SureScriptProvidersLIST(result.userId).subscribe(async data => {
            await data;
            if (data == null || data.length == 0) {
              this.toastr.error('Cannot transfer the request as the provider is not authorized to prescribe Controlled Substances.');
              return;
            }
            if (!data[0].serviceLevel.includes('ControlledSubstance')) {
              this.toastr.error('Cannot transfer the request as the provider is not authorized to prescribe Controlled Substances.');
              return;
            }
            else {
              this.UpdateTransforUser(result.userId, result.roleId, selectedRow);
            }
          });
        }
        else {
          this.UpdateTransforUser(result.userId, result.roleId, selectedRow);
        }
        //this.UpdateTransforUser(result.userId, result.roleId, selectedRow);
      }
    });
  }

  UpdateTransforUser(selectUser: string, roleId: string, selectrow: IMessagingSender) {
    this.sharedService.updateReceivedToUser(selectUser, roleId, selectrow.recieverId)
      .subscribe(
        (result: any) => {
          this.toastr.success(result);
          this.getAllMessages(this.userId);
        },
        (err: any) => console.log(err)
      );
  }

  refillsData: IERxRefills[] = [];
  refillDatasource: boolean = false;
  refillRequest() {
    // alert('hello');
    this.refillDatasource = true;
    this.rxService.GetAllPrescriptionRefillsTService(sessionStorage.getItem("userId")).subscribe(data => {
      this.refillsData = data;
      //this.messages=this.messages.filter(a=>a.messageType==this.categoryId);
      this.dataSource1.data = this.refillsData;
    },
      (err: any) => console.log(err)
    );
  }
  showAllrxRequests: boolean = true;;
  getAllMessages(userId: string) {
    this.refillDatasource = true;
    this.userId = "4YStRty7kdO5YV8Yue6DPA==";
    if (this.userId != undefined && this.userId != null) {
      this.messageService.getAllMessages(this.userId, false).subscribe(data => {
        this.messages = data;
        this.messagesDataSource.data = this.messages.filter(c => c.messageName != 'New Rx');
        this.messagesDataSource.filterPredicate = this.createFilterForMessages();
        this.messagesDataSource.sort = this.sort;
      })
    }
  }

  createFilterForMessages(): (data: any, filter: string) => boolean {
    let filterFunction = function (data, filter): boolean {
      let searchTerms = JSON.parse(filter);
      return (data.patName === null || "" ? "" : data.patName).toString().toLowerCase().indexOf(searchTerms.patName.toLowerCase()) !== -1
        && (data.created === null || "" ? "" : data.created).toString().toLowerCase().indexOf(searchTerms.createdDate.toLowerCase()) !== -1
        && (data.messageName === null || "" ? "" : data.messageName).toString().toLowerCase().indexOf(searchTerms.reqType.toLowerCase()) !== -1
        && (data.priority === null || "" ? "" : data.priority).toString().toLowerCase().indexOf(searchTerms.priority.toLowerCase()) !== -1
        && (data.senderFullName === null || "" ? "" : data.senderFullName).toString().toLowerCase().indexOf(searchTerms.processedby.toLowerCase()) !== -1
        && (data.body === null || "" ? "" : data.body).toString().toLowerCase().indexOf(searchTerms.body.toLowerCase()) !== -1
        && data.status.toLowerCase().indexOf(searchTerms.status.toLowerCase()) !== -1
        ;
    }
    return filterFunction;
  }

  onelementclick(elem) {

    // this.router.navigateByUrl('/RefillRequest');
    this.router.navigate(['/RefillRequest'], { queryParams: { rfid: elem.rfid } });


  }

}
